import { Alert } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { List } from "@refinedev/mui";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { ticketTypeCols } from "../../../../tables/ticketTypeCols";
import { Event, ofEvent } from "types/event";
import { TicketType } from "../../../../types/ticketType";
import CreateTicketTypeDialog from "../CreateTicketTypeDialog";

export default function TicketTypesPage() {
  const { control } = useFormContext<Event>();
  const rsvpEnabled = useWatch({ control, name: ofEvent("rsvpEnabled") });
  const { fields, append, update } = useFieldArray({
    control,
    name: ofEvent("ticketTypes"),
    keyName: "key",
  });

  return (
    <List
      title="Tickets"
      breadcrumb={<></>}
      headerButtons={
        rsvpEnabled ? (
          <></>
        ) : (
          <CreateTicketTypeDialog
            setFormValue={(ticket: TicketType) => append(ticket)}
          />
        )
      }
    >
      {rsvpEnabled && (
        <Alert severity="info" sx={{ mb: 2 }}>
          Tickets cannot be added while attendance is enabled. Disable
          attendance on the Publish tab to manage ticket types.
        </Alert>
      )}
      <DataGrid
        rows={fields.map((ticket, index) => ({ ...ticket, index: index }))}
        columns={ticketTypeCols((ticket, index) => update(index, ticket))}
        autoHeight
        sx={{
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
        }}
        hideFooterPagination
      />
    </List>
  );
}
